export const mfn = (w) => {
  return "@media only screen and (max-width: " + w.toString() + "px)";
};
